<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";

  let loading = false;

  let company = "";
  let name = "";
  let tel = "";
  let establishment = "";
  let business = "";
  let location = "";
  let capital = "";
  let license = "";

  const handleCompany = (event) => {
    company = event.detail.value;
  };

  const handleName = (event) => {
    name = event.detail.value;
  };

  const handleTel = (event) => {
    tel = event.detail.value;
  };

  const handleEstablishment = (event) => {
    establishment = event.detail.value;
  };

  const handleBusiness = (event) => {
    business = event.detail.value;
  };

  const handleLocation = (event) => {
    location = event.detail.value;
  };

  const handleCapital = (event) => {
    capital = event.detail.value;
  };

  const handleLicense = (event) => {
    license = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/siteOperator");
    if (!data.siteOperator) {
      return;
    }
    company = data.siteOperator.company;
    name = data.siteOperator.name;
    tel = data.siteOperator.tel;
    establishment = data.siteOperator.establishment;
    business = data.siteOperator.business;
    location = data.siteOperator.location;
    capital = data.siteOperator.capital;
    license = data.siteOperator.license;
  });

  const saveSiteOperator = async () => {
    const client = ApiService.createClient();
    loading = true;
    const { data } = await client.post("/siteOperator", {
      company,
      name,
      tel,
      establishment,
      business,
      location,
      capital,
      license,
    });
    console.log(data);
    loading = false;
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">会社概要の設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="会社名"
      placeholder=""
      input={handleCompany}
      value={company}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="事業者名"
      placeholder=""
      input={handleName}
      value={name}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="電話番号"
      placeholder=""
      input={handleTel}
      value={tel}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="創業設立"
      placeholder=""
      input={handleEstablishment}
      value={establishment}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="資本金"
      placeholder=""
      input={handleCapital}
      value={capital}
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="事業内容"
      placeholder=""
      input={handleBusiness}
      value={business}
      inputType="textarea"
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="事業所"
      placeholder=""
      input={handleLocation}
      value={location}
      inputType="textarea"
    />
  </div>

  <div class="mt-6">
    <FormWithLabel
      label="許認可申請番号"
      placeholder=""
      input={handleLicense}
      value={license}
      inputType="textarea"
    />
  </div>

  <BlueButton rounded klass="mt-4" click={saveSiteOperator} {loading}>
    更新する
  </BlueButton>
</SectionBoard>
